import { get, isArray, mergeWith, set } from "lodash-es";
import { z } from "zod";
import { Injectable, createInterfaceId } from "@gitlab/needle";
import { LOG_LEVEL } from "@gitlab-org/logging";
import { EventEmitterImpl, GITLAB_API_BASE_URL, diffEmitter } from "@gitlab-org/core";
//#region src/config_service.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let CODE_SUGGESTIONS_TRACKING_EVENTS = /* @__PURE__ */ function(CODE_SUGGESTIONS_TRACKING_EVENTS) {
	CODE_SUGGESTIONS_TRACKING_EVENTS["REQUESTED"] = "suggestion_requested";
	CODE_SUGGESTIONS_TRACKING_EVENTS["LOADED"] = "suggestion_loaded";
	CODE_SUGGESTIONS_TRACKING_EVENTS["NOT_PROVIDED"] = "suggestion_not_provided";
	CODE_SUGGESTIONS_TRACKING_EVENTS["SHOWN"] = "suggestion_shown";
	CODE_SUGGESTIONS_TRACKING_EVENTS["ERRORED"] = "suggestion_error";
	CODE_SUGGESTIONS_TRACKING_EVENTS["ACCEPTED"] = "suggestion_accepted";
	CODE_SUGGESTIONS_TRACKING_EVENTS["REJECTED"] = "suggestion_rejected";
	CODE_SUGGESTIONS_TRACKING_EVENTS["CANCELLED"] = "suggestion_cancelled";
	CODE_SUGGESTIONS_TRACKING_EVENTS["STREAM_STARTED"] = "suggestion_stream_started";
	CODE_SUGGESTIONS_TRACKING_EVENTS["STREAM_COMPLETED"] = "suggestion_stream_completed";
	return CODE_SUGGESTIONS_TRACKING_EVENTS;
}({});
let SuggestionSource = /* @__PURE__ */ function(SuggestionSource) {
	SuggestionSource["cache"] = "cache";
	SuggestionSource["network"] = "network";
	return SuggestionSource;
}({});
const CodeSuggestionsConfig = z.object({
	enabled: z.boolean().optional(),
	enableSecretRedaction: z.boolean().optional(),
	additionalLanguages: z.array(z.string()).optional(),
	disabledSupportedLanguages: z.array(z.string()).optional()
});
/**
* Delivery channel for CLI system notifications.
* - `auto`: detect the terminal and notify via the most appropriate mechanism.
* - `disabled`: never notify.
*/
/**
* System notifications for the CLI. Notifications alert the user when a session needs
* attention (approval required, response ready, or error) while the terminal is unfocused.
*/
const ModelPreferences = z.object({ chat: z.object({
	name: z.string(),
	ref: z.string()
}).optional() });
/**
* Returns the effective Duo proxy mode for callers that need request-level
* transport options. Missing configuration resolves to `inherit` so existing
* deployments continue to use the language server's resolved proxy settings.
*/
const getDuoProxyMode = (duo) => duo?.proxy?.mode ?? "inherit";
/**
* ConfigService manages user configuration (e.g. baseUrl) and application state (e.g. codeCompletion.enabled)
* TODO: Maybe in the future we would like to separate these two
*/
const ConfigService = createInterfaceId("ConfigService");
let _DefaultConfigService;
(class {
	static {
		[_DefaultConfigService, _initClass] = _applyDecs(this, [Injectable(ConfigService, [])], []).c;
	}
	#config;
	#eventEmitter = diffEmitter(new EventEmitterImpl());
	constructor() {
		this.#config = {
			baseUrl: GITLAB_API_BASE_URL,
			codeCompletion: { enableSecretRedaction: true },
			telemetry: { enabled: true },
			logLevel: LOG_LEVEL.INFO,
			ignoreCertificateErrors: false,
			httpAgentOptions: {},
			duo: { enabledWithoutGitlabProject: true },
			notifications: { channel: "auto" },
			featureFlagOverrides: {},
			knowledgeGraph: {}
		};
	}
	get = (key) => {
		return key ? get(this.#config, key) : this.#config;
	};
	set = (key, value) => {
		set(this.#config, key, value);
		this.#eventEmitter.fire(this.#config);
	};
	onConfigChange = this.#eventEmitter.event;
	merge(newConfig) {
		mergeWith(this.#config, newConfig, (target, src) => isArray(target) ? src : void 0);
		this.#eventEmitter.fire(this.#config);
	}
	static {
		_initClass();
	}
});
const exampleConfig = { codeCompletion: {
	enabled: true,
	enableSecretRedaction: true,
	additionalLanguages: ["clojure"],
	disabledSupportedLanguages: ["handlebars"]
} };
//#endregion
export { CODE_SUGGESTIONS_TRACKING_EVENTS, CodeSuggestionsConfig, ConfigService, _DefaultConfigService as DefaultConfigService, ModelPreferences, SuggestionSource, exampleConfig, getDuoProxyMode };

//# sourceMappingURL=index.mjs.map